import { render } from "./base-tabpanel.vue?vue&type=template&id=0d4be768&ts=true"
import script from "./base-tabpanel.vue?vue&type=script&lang=ts"
export * from "./base-tabpanel.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__